(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["expert-quotes"] && !Shopify.designMode) return;
  try {
    
  class ExpertQuotes extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.expert-quotes__track');
      if (!this.track) return;

      this.arrows = [...this.querySelectorAll('.expert-quotes__arrow')];
      this.arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => {
          const card = this.track.querySelector('.expert-quotes__card');
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const step = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
          this.track.scrollBy({ left: step * Number(arrow.dataset.direction), behavior: 'smooth' });
        });
      });

      this.update = this.update.bind(this);
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.track);
      this.update();

      // Theme editor: bring the selected expert into view
      this.onBlockSelect = (event) => {
        if (!this.track.contains(event.target)) return;
        this.track.scrollTo({ left: event.target.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    update() {
      const { scrollLeft, clientWidth, scrollWidth } = this.track;
      const [previous, next] = this.arrows;
      this.toggleAttribute('data-static', scrollWidth <= clientWidth + 2);
      if (previous) previous.disabled = scrollLeft <= 2;
      if (next) next.disabled = scrollLeft + clientWidth >= scrollWidth - 2;
    }
  }

  if (!customElements.get('expert-quotes')) {
    customElements.define('expert-quotes', ExpertQuotes);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase"] && !Shopify.designMode) return;
  try {
    
  class ProductShowcase extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectTab(tab));
        tab.addEventListener('keydown', (event) => this.onTabKeydown(event, tab));
      });

      this.querySelectorAll('.product-showcase__panel').forEach((panel) => this.setupPanel(panel));
    }

    setupPanel(panel) {
      const track = panel.querySelector('.product-showcase__track');
      const arrows = panel.querySelector('.product-showcase__arrows');
      if (!track || !arrows) return;

      const [previous, next] = arrows.querySelectorAll('button');
      const update = () => {
        const overflow = track.scrollWidth - track.clientWidth > 2;
        arrows.hidden = !overflow;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };

      arrows.querySelectorAll('button').forEach((button) => {
        button.addEventListener('click', () => {
          const slide = track.querySelector('.product-showcase__slide');
          const step = slide ? slide.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
          track.scrollBy({ left: step * Number(button.dataset.direction), behavior: 'smooth' });
        });
      });

      track.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(track);
      update();
    }

    selectTab(selected) {
      this.tabs.forEach((tab) => {
        const isSelected = tab === selected;
        tab.setAttribute('aria-selected', String(isSelected));
        tab.tabIndex = isSelected ? 0 : -1;
        const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`);
        if (panel) panel.hidden = !isSelected;
      });
    }

    onTabKeydown(event, tab) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      const index = this.tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : -1);
      const target = this.tabs[(index + this.tabs.length) % this.tabs.length];
      this.selectTab(target);
      target.focus();
    }
  }

  if (!customElements.get('product-showcase')) {
    customElements.define('product-showcase', ProductShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    for (const details of document.querySelectorAll('details[data-top-bar-locale][open]')) {
      if (!details.contains(event.target)) details.removeAttribute('open');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    for (const details of document.querySelectorAll('details[data-top-bar-locale][open]')) {
      details.removeAttribute('open');
      details.querySelector('summary')?.focus();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trustpilot-reviews"] && !Shopify.designMode) return;
  try {
    
  class TrustpilotReviews extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.tp-reviews__track');
      if (!this.track) return;

      this.arrows = [...this.querySelectorAll('.tp-reviews__arrow')];
      this.arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => {
          const card = this.track.querySelector('.tp-review');
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const step = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
          this.track.scrollBy({ left: step * Number(arrow.dataset.direction), behavior: 'smooth' });
        });
      });

      this.update = this.update.bind(this);
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    update() {
      const { scrollLeft, clientWidth, scrollWidth } = this.track;
      const [previous, next] = this.arrows;
      if (previous) previous.disabled = scrollLeft <= 2;
      if (next) next.disabled = scrollLeft + clientWidth >= scrollWidth - 2;
    }
  }

  if (!customElements.get('trustpilot-reviews')) {
    customElements.define('trustpilot-reviews', TrustpilotReviews);
  }

  } catch(e) { console.error(e); }
})();
})();
